<template>
  <div class="AuthMenu">
    <template v-if="isAuth">
      <Route
        class="Btn ib"
        :to="authRedirect">
        {{ $t('dashboard') }}
      </Route>
      <Route
        class="Btn danger inv ib"
        data-cy="logout"
        to="Logout">
        {{ $t('logout') }}
      </Route>
    </template>
    <Route v-else class="Btn info ib" to="Login">
      {{ $t('login') }}
    </Route>
  </div>
</template>

<script>
import { getters } from '../../utils'

export default {
  computed: getters('authRedirect', 'screenSizes'),
}
</script>

<style lang="scss">
.AuthMenu {
  display: inline-block;
  margin-left: 0.25rem;
  @include xl {
    margin-left: 1rem;
  }

  .Btn {
    color: $white;
    margin-right: 1rem;

    .Icon {
      font-size: $h6;
      line-height: 1rem;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "dashboard": "Dashboard",
    "login": "Login",
    "logout": "Logout"
  }
}
</i18n>
